import gql from 'graphql-tag';

const MDMGQL = `
uid
    mdm_code
    product_type
    broadband_speed
    addon
    product_name
    compax_product_id
    title
    model_content
    short_description
    long_description
    max_broadband_speed
    min_broadband_speed
    broadband_download_lower_range
    broadband_download_higher_range
    broadband_upload_lower_range
    broadband_upload_higher_range
    placeholder_and_image {
      Placeholder {
        media {
          url
        }
        desktopImagePosition {
          position
        }
        alt
        URL
        targetNewPage
        copy
        videoAspectRatio
        backupMedia {
          url
        }
      }
      Image {
        media {
          url
        }
        desktopImagePosition {
          position
        }
        alt
        URL
        targetNewPage
        copy
        videoAspectRatio
        backupMedia {
          url
        }
      }
    }
`;

export const MDM_QUERY = gql`
  query MdmQuery($uid: String!) {
    mdms(where: { uid: $uid }) {
      ${MDMGQL}
    }
  }
`;

export const MDM_LIST_QUERY = gql`
  query MdmListQuery($uidList: [String!]!) {
    mdms(where: { uid: $uidList }) {
      ${MDMGQL}
    }
  }
`;
